import styled from 'styled-components';
import Video from '../Video';

export const StyledSquareVideo = styled(Video)`
  position: relative;
  width: 100%;
  padding-bottom: 100%; /* 1:1 */
  height: 0;
`;
